import { Component } from '@angular/core';

import { SimulatorConfig } from '../../../core/models/simulation.model';
import { SimulatorType } from '../../../core/enums/simulator-type.enum';
import { BasicSimulatorComponent } from '../../../common/basic-simulator/basic-simulator.component';

@Component({
  selector: 'app-pore-throat-size-distributions',
  imports: [BasicSimulatorComponent],
  templateUrl: './pore-throat-size-distributions.component.html',
  styleUrl: './pore-throat-size-distributions.component.scss',
  standalone: true,
})
export class PoreThroatSizeDistributionsComponent {
  readonly config: SimulatorConfig = {
    title: 'Subsample - Pore Throat Size Distribution Simulation',
    simulatorType: SimulatorType.SubsamplePtsd,
  }
}
